import { ChipColor } from '../components/pan-chip/pan-chip.component';
import { CaseStatus } from '../types';

export function getCaseStatusColor(status: string): ChipColor {
  switch (status) {
    case CaseStatus.New:
      return 'primary';
    case CaseStatus.Viewed:
      return 'info';
    case CaseStatus.ViewedByClient:
      return 'warning';
    case CaseStatus.Resolved:
      return 'success';
    case CaseStatus.Reopened:
      return 'danger';
    case CaseStatus.Archived:
      return 'default';
    default:
      return 'default';
  }
}

export function getCaseStatusText(status: string): string {
  switch (status) {
    case CaseStatus.New:
      return 'New';
    case CaseStatus.Viewed:
      return 'Viewed';
    case CaseStatus.ViewedByClient:
      return 'Viewed By Client';
    case CaseStatus.Resolved:
      return 'Resolved';
    case CaseStatus.Reopened:
      return 'Reopened';
    case CaseStatus.Archived:
      return 'Archived';
    default:
      return status;
  }
}
